var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodataInqueryBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 284,
    viewBox: "0 0 350 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.538 150H13.4619C12.6545 150 12 151.045 12 152.333V161.667C12 162.955 12.6545 164 13.4619 164H173.538C174.345 164 175 162.955 175 161.667V152.333C175 151.045 174.345 150 173.538 150Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2108 174H12.7892C12.3534 174 12 175.045 12 176.333V185.667C12 186.955 12.3534 188 12.7892 188H99.2108C99.6466 188 100 186.955 100 185.667V176.333C100 175.045 99.6466 174 99.2108 174Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.632 174H231.368C231.165 174 231 175.045 231 176.333V185.667C231 186.955 231.165 188 231.368 188H271.632C271.835 188 272 186.955 272 185.667V176.333C272 175.045 271.835 174 271.632 174Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3557 119H12.6443C12.2885 119 12 119.784 12 120.75V138.25C12 139.216 12.2885 140 12.6443 140H59.3557C59.7115 140 60 139.216 60 138.25V120.75C60 119.784 59.7115 119 59.3557 119Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.538 251H13.4619C12.6545 251 12 252.045 12 253.333V262.667C12 263.955 12.6545 265 13.4619 265H173.538C174.345 265 175 263.955 175 262.667V253.333C175 252.045 174.345 251 173.538 251Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2108 275H12.7892C12.3534 275 12 276.045 12 277.333V286.667C12 287.955 12.3534 289 12.7892 289H99.2108C99.6466 289 100 287.955 100 286.667V277.333C100 276.045 99.6466 275 99.2108 275Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.632 275H231.368C231.165 275 231 276.045 231 277.333V286.667C231 287.955 231.165 289 231.368 289H271.632C271.835 289 272 287.955 272 286.667V277.333C272 276.045 271.835 275 271.632 275Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3557 220H12.6443C12.2885 220 12 220.784 12 221.75V239.25C12 240.216 12.2885 241 12.6443 241H59.3557C59.7115 241 60 240.216 60 239.25V221.75C60 220.784 59.7115 220 59.3557 220Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.538 49H13.4619C12.6545 49 12 50.0447 12 51.3333V60.6667C12 61.9553 12.6545 63 13.4619 63H173.538C174.345 63 175 61.9553 175 60.6667V51.3333C175 50.0447 174.345 49 173.538 49Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2108 73H12.7892C12.3534 73 12 74.0447 12 75.3333V84.6667C12 85.9553 12.3534 87 12.7892 87H99.2108C99.6466 87 100 85.9553 100 84.6667V75.3333C100 74.0447 99.6466 73 99.2108 73Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.632 73H231.368C231.165 73 231 74.0447 231 75.3333V84.6667C231 85.9553 231.165 87 231.368 87H271.632C271.835 87 272 85.9553 272 84.6667V75.3333C272 74.0447 271.835 73 271.632 73Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3557 18H12.6443C12.2885 18 12 18.7835 12 19.75V37.25C12 38.2165 12.2885 39 12.6443 39H59.3557C59.7115 39 60 38.2165 60 37.25V19.75C60 18.7835 59.7115 18 59.3557 18Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20 -16H370V284H-20V-16Z",
    fill: "url(#paint0_linear_46_6)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_46_6",
    x1: 175,
    y1: -121.682,
    x2: 175,
    y2: 209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 284,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodataInqueryBg);
export default __webpack_public_path__ + "static/media/nodata_inquery_bg.357001dada94c7a5193a5cb08e9c5de9.svg";
export { ForwardRef as ReactComponent };